import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "field" }
const _hoisted_2 = { class: "field__title" }

import { computed, reactive, ref, Ref } from "vue";
import { TInputType } from "@/types";
import vueFilePond from "vue-filepond";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size";
import FilePondPluginFileEncode from "filepond-plugin-file-encode";

interface IProps {
  name: string;
  type?: TInputType;
  value?: string | number;
  options?: { key: string; name: string | "" }[];
  required?: boolean;
  validations?: string[] | null;
  file?: {
    types: string;
    fileSize: number;
    overallSize: number;
    filesAmount: number;
  };
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppFileUpload',
  props: {
    name: null,
    type: null,
    value: null,
    options: null,
    required: { type: Boolean },
    validations: null,
    file: { default: () => {
    return {
      types: "image/parseStringStyle, image/lpg",
      fileSize: 300,
      overallSize: 1200,
      filesAmount: 5
    };
  } }
  },
  emits: ["dataChange"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: "dataChange", value: string | number, name: string | ""): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { name: string, type?: TInputType, value?: string | number, options?: { key: string; name: string | "" }[], required?: boolean, validations?: string[] | null, file: {
    types: string;
    fileSize: number;
    overallSize: number;
    filesAmount: number;
  } }

const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview,
  FilePondPluginFileValidateSize,
  FilePondPluginFileEncode
);

const pond = ref(null);



const files: Ref<string | number> = ref(props.value ?? "");

const fileData = reactive({
  fileTypes: props.file?.types,
  fileOverallSize: props.file?.overallSize,
  fileSize: props.file?.fileSize,
  filesAmount: props.file?.filesAmount
});

const label = computed((): string | undefined => {
  return `
      <span class="label-top">Переместите изображения в это поле или нажмите и <span class='highlight'> выберите на своем устройстве </span></span>
      <span class="label-info">Принимаются до ${fileData.filesAmount} файл формата ${humanTypes.value}, размером не более ${fileData.fileSize} Kb</span>
      `;
});

const isMultiple = computed((): boolean => {
  return fileData.filesAmount && fileData.filesAmount > 1 ? true : false;
});

const getFile64 = (files: any): void => {
  if (!files) return;
  let filesString: string;

  filesString = files
    .map((file: any) => {
      return file.getFileEncodeDataURL();
    })
    .join(", ");

  emits("dataChange", filesString, props.name);

  console.log(filesString);
};

const humanTypes = computed((): string | undefined => {
  return fileData.fileTypes
    ? fileData.fileTypes
        .split(",")
        .map((item) => {
          let trimmed = item.trim();
          let final =
            trimmed.indexOf("/") > -1
              ? trimmed.slice(trimmed.indexOf("/") + 1, trimmed.length)
              : trimmed;
          return final.toUpperCase();
        })
        .join(", ")
    : "";
});



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", _hoisted_1, [
    _createElementVNode("legend", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _createVNode(_unref(FilePond), {
      name: props.name,
      ref_key: "pond",
      ref: pond,
      "allow-multiple": _unref(isMultiple),
      "label-idle": _unref(label),
      onUpdatefiles: getFile64,
      "accepted-file-types": fileData.fileTypes,
      "allow-file-encode": true,
      "allow-file-size-validation": "true",
      "label-file-type-not-allowed": "Файл неверного формата",
      "file-validate-type-label-expected-types": 
        'Принимаются файлы формата ' + _unref(humanTypes)
      ,
      "max-file-size": fileData.fileSize,
      "max-files": fileData.fileOverallSize
    }, null, 8, ["name", "allow-multiple", "label-idle", "accepted-file-types", "file-validate-type-label-expected-types", "max-file-size", "max-files"])
  ]))
}
}

})